import {BasePhoneNumberValidator} from './validator';

export {PhoneNumberDirective} from './directive';
export {PhoneNumberPipe} from './pipe';
export {ExtraPhoneNumberControlValidators} from './validator';

export const PHONE_NUMBER_VALIDATORS = [BasePhoneNumberValidator];
